import React from 'react';
import RequestPayment from './RequestPayment';
import BaseModal, {
	BaseModalProps,
} from '../../Modules/Base/Components/BaseModal/BaseModal';
import { Size } from '../../Enums/Size.enum';

interface Props extends BaseModalProps {
	caseId: string;
}

const RequestPaymentModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.requestPayment' size={Size.SM}>
			<RequestPayment caseId={props.caseId} onSuccess={props.onClose} />
		</BaseModal>
	);
};

export default RequestPaymentModal;
